import React, { cloneElement, useMemo, isValidElement, } from 'react';
import { useFloating, useInteractions, useClick, useRole, useDismiss, useId, FloatingPortal, FloatingFocusManager, useTransitionStyles, } from '@floating-ui/react';
import { ModalBase, Content, Footer, FloatingOverlay } from './styled';
import Heading from './Heading';
function Modal({ open, onClose, heading, content, children, footer, trigger, disableAnimation, }) {
    const { reference, floating, context } = useFloating({
        open,
        onOpenChange: onClose,
    });
    const { isMounted, styles } = useTransitionStyles(context, {
        duration: disableAnimation ? 0 : 100,
    });
    const id = useId();
    const labelId = `${id}-label`;
    const descriptionId = `${id}-description`;
    const { getReferenceProps, getFloatingProps } = useInteractions([
        useClick(context),
        useRole(context),
        useDismiss(context),
    ]);
    const triggerWithProps = useMemo(() => isValidElement(trigger) &&
        cloneElement(trigger, getReferenceProps(Object.assign({ ref: reference }, trigger.props))), [trigger, reference, getReferenceProps]);
    const childrenWithProps = useMemo(() => {
        if (children) {
            return React.Children.map(children, (child) => {
                if (isValidElement(child) && child.type === Heading) {
                    return cloneElement(child, {
                        labelId,
                        onClose,
                    });
                }
                return child;
            });
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Heading, { labelId: labelId, onClose: onClose }, heading),
            React.createElement(Content, null, content),
            React.createElement(Footer, null, footer)));
    }, [children, heading, footer, content, onClose, labelId]);
    return (React.createElement(React.Fragment, null,
        triggerWithProps,
        React.createElement(FloatingPortal, null, isMounted && (React.createElement(FloatingOverlay, { lockScroll: true, style: Object.assign({}, styles) },
            React.createElement(FloatingFocusManager, { context: context },
                React.createElement(ModalBase, Object.assign({}, getFloatingProps({
                    ref: floating,
                    className: 'dialog',
                    'aria-labelledby': labelId,
                    'aria-describedby': descriptionId,
                })), childrenWithProps)))))));
}
export default Modal;
